import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { LenderLicensesStore } from '../stores/lenderLicensesStore';

export const useLenderLicensesStore = () =>
  useContext<{ lenderLicensesStore: LenderLicensesStore }>(StoreContext);
